var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEyedropper = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1172 8.18514L11.2988 7.99178C11.6211 7.6578 11.627 7.26522 11.293 6.93124L11.1289 6.76717C12.0605 5.94686 13.0684 5.86483 13.7246 5.20272C14.6328 4.2828 14.3984 2.95858 13.7012 2.25545C13.0098 1.55233 11.6855 1.32967 10.7539 2.23202C10.0859 2.88241 10.0098 3.89608 9.18945 4.82772L9.03125 4.66366C8.69727 4.32381 8.29883 4.33553 7.96484 4.6578L7.77148 4.83944C7.37891 5.20858 7.4375 5.56014 7.78906 5.90584L8.02344 6.14608L3.73437 10.4351C1.84766 12.3219 2.59766 12.2867 1.67773 13.564L2.28125 14.1969C3.51758 13.2769 3.58789 14.109 5.49219 12.2164L9.81055 7.92733L10.0508 8.16756C10.4023 8.51327 10.7422 8.57186 11.1172 8.18514ZM6.25977 9.72616C6.06641 9.50936 6.10742 9.31014 6.31836 9.09335L8.63867 6.75545L9.21289 7.32967L6.875 9.67342C6.68164 9.86092 6.44141 9.91952 6.25977 9.72616Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEyedropper);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-eyedropper.ec3a31bf6e042a6d62721ea8b5454eb5.svg";